
import { RegistratioData } from '../../../../../model/registration-data';
import { TrackTypes } from '../../model/track-types';
import { RegistratioJourney } from '../../../../../model/registration-journey';
import { UserModel } from '../../../../user-registration/model/user-registration.model';

export class UserRegistrationParseData {

    public static formatToRegistrationJourney(data: UserModel, journey: TrackTypes): RegistratioJourney {
        const newData = new RegistratioData();

        if (data.data) {
            return {
                journeyType: journey,
                data: {
                    profileData: {
                        ...newData.profileData,
                        name: data.data?.dados_pessoais?.nome_fantasia_apelido,
                        email: data.data?.dados_contato?.email,
                        phoneNumber: data?.data?.dados_contato?.telefone,
                    },
                    situacao:{
                        descricao_fluxo: data?.data?.situacao?.descricao_fluxo,
                        id_fluxo: data?.data?.situacao?.id_fluxo,
                        id_pessoa: data?.data?.situacao?.id_pessoa,
                        redireciona_app_itau: data?.data?.situacao?.redireciona_app_itau,
                    },
                    personalData: {
                        ...newData.personalData,
                        firstEdit: [],
                        editData: data.data?.dados_contato?.campos_editaveis,
                        isCompleted: data.data?.dados_pessoais?.informacoes_completas,
                        name: data.data?.dados_pessoais?.nome,
                        cpf: data.data?.dados_pessoais?.cpf,
                        documentName: data.data?.dados_pessoais?.nome_completo_documento,
                        documentType: data.data?.dados_pessoais?.documento_codigo,
                        documentTypeName: data.data?.dados_pessoais?.documento_descricao,
                        documentNumber: data.data?.dados_pessoais?.documento_numero,
                        dateOfBirth: data.data?.dados_pessoais?.data_nascimento,
                        issuingAgency: data.data?.dados_pessoais?.orgao_expedidor_codigo,
                        issuingAgencyName: data.data?.dados_pessoais?.orgao_expedidor_descricao,
                        expeditionState: data.data?.dados_pessoais?.documento_estado_expedicao_sigla,
                        expeditionStateName: data.data?.dados_pessoais?.documento_estado_expedicao_descricao,
                        ufOfTheIssuingAgency: data.data?.dados_pessoais?.documento_estado_expedicao_sigla,
                        cityOfBirth: data.data?.dados_pessoais?.cidade_nascimento_codigo,
                        cityOfBirthName: data.data?.dados_pessoais?.cidade_nascimento,
                        uFOfBirthName: data.data?.dados_pessoais?.uf_nascimento_descricao,
                        uFOfBirth: data.data?.dados_pessoais?.uf_nascimento_sigla,
                        countryOfBirthName: data.data?.dados_pessoais?.pais_nascimento_descricao,
                        countryOfBirth: data.data?.dados_pessoais?.pais_nascimento_sigla,
                        regionBirthFoundation: data.data?.dados_pessoais?.regiao_nascimento_fundacao,
                        nationality: data.data?.dados_pessoais?.nacionalidade_codigo,
                        nationalityName: data.data?.dados_pessoais?.nacionalidade_descricao,
                        motherName: data.data?.dados_pessoais?.nome_mae,
                        gender: data.data?.dados_pessoais?.genero_codigo,
                        genderName: data.data?.dados_pessoais?.genero_descricao,
                        genderCode: data.data?.dados_pessoais?.genero_sigla,
                        age: data.data?.dados_pessoais?.idade,
                        phoneNumber: data.data?.dados_contato?.telefone,
                        email: data.data?.dados_contato?.email,
                    },
                    maritalStatus: {
                        ...newData.maritalStatus,
                        firstEdit: [],
                        editData: data.data?.estado_civil?.campos_editaveis,
                        isCompleted: data.data?.estado_civil?.estado_civil === '0' ? false : data.data?.estado_civil?.informacoes_completas,
                        maritalStatus: data.data?.estado_civil?.estado_civil === '0' ? undefined : data.data?.estado_civil?.estado_civil,
                        maritalStatusName: data.data?.estado_civil?.estado_civil === '0'
                            ? undefined : data.data?.estado_civil?.estado_civil_descricao,
                        foreignSpouse: !data.data?.estado_civil?.conjuge_cpf || data.data?.estado_civil?.conjuge_cpf === '' ? true : false,
                        spouseCpf: data.data?.estado_civil?.conjuge_cpf
                            ? this.formartCPF(data.data?.estado_civil?.conjuge_cpf)
                            : data.data?.estado_civil?.conjuge_cpf,
                        spouseName: data.data?.estado_civil?.conjuge_nome,
                    },
                    address: {
                        ...newData.address,
                        firstEdit: [],
                        editData: data.data?.endereco?.campos_editaveis,
                        isCompleted: data.data?.endereco?.informacoes_completas,
                        adjunct: data.data?.endereco?.complemento === '' ? undefined : data.data?.endereco?.complemento,
                        city: data.data?.endereco?.cidade,
                        cityName: data.data?.endereco?.cidade,
                        district: data.data?.endereco?.bairro === '' ? undefined : data.data?.endereco?.bairro,
                        number: data.data?.endereco?.numero === '' ? undefined : data.data?.endereco?.numero,
                        postalCode: data.data?.endereco?.cep === '' ? undefined : data.data?.endereco?.cep,
                        state: data.data?.endereco?.estado,
                        stateName: data.data?.endereco?.estado,
                        street: data.data?.endereco?.rua === '' ? undefined : data.data?.endereco?.rua,
                    },
                    professionalData: {
                        ...newData.professionalData,
                        firstEdit: [],
                        editData: data.data?.dados_profissionais?.campos_editaveis,
                        isCompleted: data.data?.dados_profissionais?.origem_renda_codigo === '0'
                            ? false : data.data?.dados_profissionais?.informacoes_completas,
                        entityCnpj: data.data?.dados_profissionais?.empresa_cnpj,
                        entityThatWorks: data.data?.dados_profissionais?.empresa_nome,
                        originIncome: data.data?.dados_profissionais?.origem_renda_codigo === '0'
                            ? undefined : data.data?.dados_profissionais?.origem_renda_codigo,
                        originIncomeName: data.data?.dados_profissionais?.origem_renda_descricao,
                        profession: data.data?.dados_profissionais?.profissao_codigo === '0'
                            ? undefined : data.data?.dados_profissionais?.profissao_codigo,
                        professionName: data.data?.dados_profissionais?.profissao_descricao,
                        incomeRequired: data.data?.patrimonio?.renda_obrigatoria,
                        patrimonyRequired: data.data?.patrimonio?.patrimonio_obrigatorio,
                    },
                    incomeEquity: {
                        ...newData.incomeEquity,
                        firstEdit: [],
                        editData: data.data?.patrimonio?.campos_editaveis,
                        isCompleted: data.data?.patrimonio?.informacoes_completas,
                        income: data.data?.patrimonio?.renda,
                        patrimony: data.data?.patrimonio?.patrimonio,
                        noIncome: data.data?.patrimonio?.sem_renda_faturamento,
                        noPatrimony: data.data?.patrimonio?.sem_patrimonio,
                        personLinkedToTheBrokerage: data.data?.dados_pessoais?.vinculo_corretora,

                        taxResidence: data.data?.patrimonio?.residencias_fiscais.length === 0 
                        ? data.data?.patrimonio?.pais_residencia_fiscal_sigla 
                        : data.data?.patrimonio?.residencias_fiscais[0]?.pais_residencia_fiscal_sigla,

                        taxResidenceName: data.data?.patrimonio?.residencias_fiscais.length === 0 
                        ? data.data?.patrimonio?.pais_residencia_fiscal_nome 
                        : data.data?.patrimonio?.residencias_fiscais[0]?.pais_residencia_fiscal_nome,

                        nif: data.data?.patrimonio?.residencias_fiscais[0]?.numero_identificacao_fiscal,
                        dateTaxResidency: data.data?.patrimonio?.residencias_fiscais[0]?.data_residencia_fiscal
                    },
                    idInvestor: data.data?.id_investidor,
                    contaIon: data.data?.dados_pessoais?.conta_ion,
                }
            }
        } else {
            return {
                data: {
                    errorData: {
                        ...newData.errorData,
                        data: data?.errorData?.data,
                        code: data?.errorData?.code,
                        message: data?.errorData?.message
                    }
                }
            }
        };
    }

    public static formartCPF(value: string): string {
        const cpf = value?.replace(/\D+/g, '');

        if (cpf?.length === 14 && cpf?.substring(0, 3) === '000') {
            return cpf?.substring(3);
        } else {
            return cpf;
        }
    }
}
